module.exports = __webpack_public_path__ + "static/media/copy.894c3c46.svg";